// Per-domain integrations page (MIS-811 / Task 30).
//
// Renders the masked credential manager (IntegrationsForm) scoped to the route's
// `:domainId`. Data, mutations and RBAC handling live in IntegrationsForm; this
// route just supplies the param + page chrome.

import { createFileRoute, Link } from '@tanstack/react-router';
import { IntegrationsForm } from '@/components/integrations/IntegrationsForm';

export const Route = createFileRoute('/_authenticated/domains/$domainId/integrations')({
  component: DomainIntegrationsPage,
});

function DomainIntegrationsPage() {
  const { domainId } = Route.useParams();
  return (
    <div className="mx-auto max-w-3xl space-y-6 p-8">
      <div>
        <Link
          to="/domains/$domainId"
          params={{ domainId }}
          className="text-sm text-gray-500 hover:underline"
        >
          ← Domain
        </Link>
        <h1 className="mt-2 text-xl font-semibold text-gray-900">Integrations</h1>
        <p className="mt-1 text-sm text-gray-500">
          Per-domain credentials are encrypted at rest and never shown in plaintext after saving.
        </p>
      </div>
      <IntegrationsForm domainId={domainId} />
    </div>
  );
}
